'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const universal_color = require('../../style/universal.color.js');

// Props for the Link Component

// Decoration types for the link
var LinkDecorationTypes = /*#__PURE__*/function (LinkDecorationTypes) {
  LinkDecorationTypes["NONE"] = "none";
  LinkDecorationTypes["UNDERLINE"] = "underline";
  LinkDecorationTypes["DOTTED"] = "dotted";
  return LinkDecorationTypes;
}({});

// The props passed to the <a> element

// Types used for Styling the Link
var LinkTypes = /*#__PURE__*/function (LinkTypes) {
  LinkTypes["PRIMARY"] = "primary";
  LinkTypes["SECONDARY"] = "secondary";
  return LinkTypes;
}({});

// The color theme for the link
var LinkColors = {
  primary: {
    base: universal_color.linkBlue,
    hover: universal_color.starsBlue
  },
  secondary: {
    base: universal_color.mlbGrey4,
    hover: universal_color.linkBlue
  },
  dark: {
    base: universal_color.linkBlueOnDark,
    hover: universal_color.linkBlue
  }
};

exports.LinkColors = LinkColors;
exports.LinkDecorationTypes = LinkDecorationTypes;
exports.LinkTypes = LinkTypes;
